import { BASE_HANDLER_URL } from "..";
import { DEFAULT_GRID_INFO_CLIENT_TASK } from "../../Components/ClientDetail/ClientTask/KendoClientDetailTask";

export const loadClientTaskGridData = async (taskFilter, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_TASK.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_TASK.pageSize;
  const currentSortName =
    gridState.sortName ?? DEFAULT_GRID_INFO_CLIENT_TASK.sortName;
  const currentSortOrder =
    gridState.sortOrder ?? DEFAULT_GRID_INFO_CLIENT_TASK.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      status: taskFilter.status,
      entitySeqNum: taskFilter.clientId,
      APPUSER: sessionStorage.USER,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_CLIENT_TASK.className
    }&action=${DEFAULT_GRID_INFO_CLIENT_TASK.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    // hideLoader();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
